'use client';
import _split from 'lodash/split';
import _floor from 'lodash/floor';
import _forEach from 'lodash/forEach';
import _last from 'lodash/last';
import _size from 'lodash/size';
import { usePathname } from 'next/navigation';
import {
  // babyIntermediaryUrls,
  // toddlerIntermediaryUrls,
  // preSchoolerIntermediaryUrls,
  // childIntermediaryUrls,
  teenaagerIntermediaryUrls,
  youngAdultIntermediaryUrls,
  youngProfessionalIntermediaryUrls,
  professionalAdultIntermediaryUrls,
  middleAgedAdultIntermediaryUrls,
  lateMiddleAgedAdultIntermediaryUrls,
  retireesIntermediaryUrls,
  seniorsIntermediaryUrls,
} from './chartUrlsByAgeAndGender';
import { plural } from 'pluralize';
import { getLifeStage } from './lm_title_description_service';
import { parseUrlForGenderWithString } from './maps';
import { parseUrlForSimpleChartType } from './lm_utilities';
import { getFormattedUTCDate } from './charts_utils';
import { normalizeLocaleForImage } from './normalizeLocaleForImage';

const XDate = require('xdate');
// import { useRouter } from 'next/router';

// const formulateAgeUrlFragment = function (formObj, age) {
//   var _age = '';
//   // console.log(formObj)
//   /*
//      params: `age` is fetched in months
//      */
//   if (age <= 3) {
//     var dob = new XDate(formObj.dob);
//     var measure_dob = new XDate(formObj.md);
//     _age = _floor(dob.diffWeeks(measure_dob)) + '-week-old-baby';
//   } else if (age > 3 && age < 4) {
//     _age = '12-week-old-baby';
//   } else if (age >= 4 && age <= 11) {
//     _age = _floor(age) + '-month-old-baby';
//   } else if (age > 11 && age < 12) {
//     _age = _floor(age) + '-month-old-baby';
//   } else if (age === 12) {
//     _age = '1-year-old-baby';
//   } else if (age > 12 && age < 13) {
//     _age = '1-year-old-baby';
//   } else if (age >= 13 && age <= 23) {
//     _age = _floor(age) + '-month-old';
//   } else if (age > 23 && age < 24) {
//     _age = _floor(age) + '-month-old';
//   } else if (age === 24) {
//     _age = '2-year-old';
//   } else if (age > 24 && age < 25) {
//     _age = '2-year-old';
//   } else if (age >= 25 && age < 36) {
//     var q = _floor(age / 12);
//     var r = _floor(age % 12);
//     if (r === 1) {
//       _age = q + '-years-' + r + '-month';
//     } else if (r === 0) {
//       _age = q + '-years-old';
//     } else {
//       _age = q + '-years-' + r + '-months';
//     }
//   } else if (age === 36) {
//     _age = '3-years-old';
//   } else if (age > 36 && age <= 240) {
//     var q = _floor(age / 12);
//     var r = _floor(age % 12);
//     if (r === 1) {
//       _age = q + '-years-' + r + '-month';
//     } else if (r === 0) {
//       _age = q + '-years-old';
//     } else {
//       _age = q + '-years-' + r + '-months';
//     }
//   } else if (age >= 240) {
//     var years = Math.round(age / 12);
//     _age = years + '-years-old';
//   }
//   return _age;
// };
// TODO // CODE TO REMOVE ABOVE
const formulateAgeUrlFragment = function (formObj, age) {
  // `age` is in months — convert to years
  const years = Math.round(age / 12);

  // Ensure only full-year format is returned
  return `${years}-years-old`;
};

const formulateGenderUrlFragment = function (gender, age) {
  var g_fragment = '';

  switch (gender) {
    case 'm':
      g_fragment = '/men/';
      break;
    case 'f':
      g_fragment = '/women/';
      break;
    case 'h':
      g_fragment = '/household/';
      break;
    default:
      g_fragment = '/men/';
      break;
  }

  return g_fragment;
};

const formulateGenderFromUrlFragment = function (_gender) {
  let gender = '';
  // let genderurl = splitUrlToParts()[2];

  switch (_gender) {
    case 'men':
      gender = 'm';
      break;
    case 'women':
      gender = 'f';
      break;
    case 'household':
      gender = 'h';
      break;
    default:
      gender = 'm';
      break;
  }

  return gender;
};

const formulateChartUrl = function (formObj, type, age, urlUnit) {
  // if (age > 0 && age <= 240) {
  var url = '/';
  var _type = type;
  var _gender = formulateGenderUrlFragment(formObj.gender, age);
  var _age = formulateAgeUrlFragment(formObj, age);

  return url + _type + _gender + _age + (urlUnit ? `/${urlUnit}` : '');
  // }
};

const calculateDobPerLocation = function (location) {
  var myDate = new Date();
  var dayOfMonth = myDate.getDate();
  var loc_array = _split(location, '/');
  var lastElement = _last(loc_array);
  var lastElementArray = _split(lastElement, '-'),
    days = 0;

  if (lastElementArray[1] === 'year' || lastElementArray[1] === 'years') {
    days = parseInt(lastElementArray[0]) * 366;
    if (_size(lastElementArray) > 3 && (_last(lastElementArray) === 'month' || _last(lastElementArray) === 'months')) {
      days = days + parseInt(lastElementArray[2]) * 31;
    }
    myDate.setDate(dayOfMonth - days); // Subtracted 1 for a issue where the date was wrong
  } else if (lastElementArray[1] === 'month' || lastElementArray[1] === 'months') {
    days = parseInt(lastElementArray[0]) * 31;
    myDate.setDate(dayOfMonth - days);
  } else if (lastElementArray[1] === 'week' || lastElementArray[1] === 'weeks') {
    days = parseInt(lastElementArray[0]) * 7;
    myDate.setDate(dayOfMonth - days);
  } else {
    myDate.setDate(dayOfMonth - 365);
  }

  return myDate;
};

// const splitUrlToParts = function () {
//   const router = usePathname();
//   // return window.location.pathname.split('/');
//   return router.split('/');
// };
const splitUrlToParts = (pathname) => {
  if (!pathname) return [];
  return pathname.split('/').filter(Boolean);
};

// const getFileName = (blurbData, hashArray, url) => {
//   let fileName =
//     hashArray[3] +
//     ' ' +
//     plural(getLifeStage(url)) +
//     ' ' +
//     parseUrlForSimpleChartType(splitUrlToParts()[0]) +
//     ' ' +
//     parseUrlForGenderWithString(hashArray, locale) +
//     ' chart';
//   fileName = fileName.toLowerCase().replaceAll(' ', '-');

//   return fileName;
// };
const getFileName = (blurbData, hashArray, url, date = null, locale = 'en-US') => {
  // Coerce to image-locale (collapses en-* variants to en-US; unwraps region objects).
  const imageLocale = normalizeLocaleForImage(locale);
  const splitParts = splitUrlToParts(url); // already safe
  const baseFileName =
    hashArray[3] +
    ' ' +
    plural(getLifeStage(url, imageLocale)) +
    ' ' +
    parseUrlForSimpleChartType(splitParts[0]) +
    ' ' +
    parseUrlForGenderWithString(hashArray, imageLocale) +
    ' chart';

  const cleanFileName = baseFileName.toLowerCase().replaceAll(' ', '-');

  if (date) {
    // Add date in yyyymmdd format
    const formattedDate = getFormattedUTCDate(date);
    return `${cleanFileName}-${formattedDate}`;
  }

  return cleanFileName;
};

// const getChartImageAltValue = (blurbData, hashArray, url) => {
//   let fileName =
//     blurbData?.ageDesc +
//     ' ' +
//     plural(getLifeStage(url)) +
//     ' ' +
//     parseUrlForSimpleChartType(splitUrlToParts()[0]) +
//     ' ' +
//     parseUrlForGenderWithString(hashArray, locale) +
//     ' chart';
//   fileName = fileName.toLowerCase();
//   return fileName;
// };
// const getChartImageAltValue = (blurbData, hashArray, url) => {
//   const pathnameParts = splitUrlToParts(url);

//   const fileName =
//     (blurbData?.ageDesc ?? '') +
//     ' ' +
//     plural(getLifeStage(url)) +
//     ' ' +
//     parseUrlForSimpleChartType(pathnameParts?.[0]) +
//     ' ' +
//     parseUrlForGenderWithString(hashArray, locale) +
//     ' chart';

//   return fileName.toLowerCase();
// };
const getChartImageAltValue = (blurbData, hashArray, url, date = null, locale = 'en-US') => {
  // Alt text uses the real viewer locale (translated → screen readers + SEO).
  const pathnameParts = splitUrlToParts(url);

  let fileName =
    (blurbData?.ageDesc ?? '') +
    ' ' +
    plural(getLifeStage(url, locale)) +
    ' ' +
    parseUrlForSimpleChartType(pathnameParts?.[0]) +
    ' ' +
    parseUrlForGenderWithString(hashArray, locale) +
    ' chart';

  fileName = fileName.toLowerCase();

  if (date) {
    const formattedDate = getFormattedUTCDate(date);
    fileName += ` ${formattedDate}`;
  }

  return fileName;
};
export {
  // babyIntermediaryUrls,
  // toddlerIntermediaryUrls,
  // preSchoolerIntermediaryUrls,
  // childIntermediaryUrls,
  teenaagerIntermediaryUrls,
  youngAdultIntermediaryUrls,
  youngProfessionalIntermediaryUrls,
  professionalAdultIntermediaryUrls,
  middleAgedAdultIntermediaryUrls,
  lateMiddleAgedAdultIntermediaryUrls,
  retireesIntermediaryUrls,
  seniorsIntermediaryUrls,
  formulateChartUrl,
  calculateDobPerLocation,
  formulateGenderFromUrlFragment,
  getFileName,
  getChartImageAltValue,
};
